export default "__VITE_ASSET__CF9Wfbve__"